import axios from './../../api';
import store from './../../store';
import Constants from './../../constants';

export default {
  namespaced: true,

  state: {
    beneficiariesReferent:[],
    beneficiariesToAdd:[],
    beneficiaryReferentToEdit:{},
    specificRightsToEdit:{},
    selectedBeneficiaries:[],
  },
  getters:{
    beneficiariesReferent(state){
      return state.beneficiariesReferent;
    },

    beneficiariesToAdd(state){
      return state.beneficiariesToAdd;
    },

    beneficiaryReferentToEdit(state){
      return state.beneficiaryReferentToEdit;
    },

    specificRightsToEdit(state){
      return state.specificRightsToEdit;
    },

    selectedBeneficiaries(state){
      return state.selectedBeneficiaries;
    }
  },
  mutations: {
    SET_BENEFICIARIESREFERENT(state, list){
      state.beneficiariesReferent = list;
    },

    SET_BENEFICIARIESTOADD(state, list){
      state.beneficiariesToAdd = list;
    },

    SET_BENEFICIARYREFERENTTOEDIT(state, beneficiary){
      state.beneficiaryReferentToEdit = JSON.parse(JSON.stringify(beneficiary));
    },

    SET_SPECIFICRIGHTSTOEDIT(state, rights){
      state.specificRightsToEdit = rights;
    },

    SET_SELECTEDBENEFICIARIES(state, beneficiaries){
      state.selectedBeneficiaries = beneficiaries;
    }
  },
  actions:{
    /**
         * load all beneficiaries attach to a specific referent
         * @param {*} context
         * @param int id
         */
    async loadBeneficiariesReferent(context, idReferent){
      await store.dispatch('beneficiaries/loadBeneficiaries', { hasLoading: false, hasPagination: 0, });
      await store.dispatch('referents/loadReferents');

      await axios.get('api/user-beneficiaries/'+idReferent).then((response) => {        
        let beneficiaries = JSON.parse(JSON.stringify(store.getters['beneficiaries/beneficiaries']));
        let beneficiariesReferent = response.data;
        
        store.commit('referents/SET_REFERENTTOEDIT', store.getters['referents/referents'].filter(referent => referent.id == idReferent)[0]);
        let referentToEdit = store.getters['referents/referentToEdit'];

        if(!referentToEdit.roles.some(role => role.type === 'admin')){        
          beneficiariesReferent.forEach(function(beneficiary) {
            beneficiary.role = beneficiary.manager_user.roles.length === 0 
              ? 'Accès spécifiques' 
              : (beneficiary.manager_user.roles[0] || {}).name;
          });
        
          //Remove all beneficiaries already add in referent beneficiaries list.
          //Reverse read direction to begin to remove since the last position
          beneficiaries.slice().reverse().forEach(function(benef, index, object) {
            if(beneficiariesReferent.filter(b => b.id == benef.id).length > 0){
              beneficiaries.splice(object.length - 1 - index, 1);
            }
          });

          //Second for loop otherwise some beneficiaries don't have rights (based on new beneficiary's referent position)
          for(let index in beneficiaries){
            beneficiaries[index].role = (referentToEdit.roles[0] || {}).name; 
            beneficiaries[index].permissions = [];
          }
        }
        context.commit('SET_BENEFICIARIESREFERENT', beneficiariesReferent);
        context.commit('SET_BENEFICIARIESTOADD', beneficiaries);
      }).catch( err => {
        console.log('error status', err.response.status);
        throw new Error('Referent unautorized');
      });
    },

    /**
     * * TODO : Delete it ? because never used
         * Add new Beneficiary in a referent permimeter
         * @param {*} context
         * @param object datas => {id_referent, id_beneficiary}
         */
    async addBeneficiaryToReferent(context, beneficiary){
      if(context.getters.beneficiariesToAdd.filter(b => b.id == beneficiary.id).length > 0){ //only if beneficiary exists
        let referent = store.getters['referents/referentToEdit'];

        await axios.post('/api/user-beneficiaries/'+referent.id, {beneficiary: beneficiary}).then(() => {
          context.dispatch('loadBeneficiariesReferent', referent.id);

          store.commit('permissions/SET_MESSAGEHEADER', {type: 'success', msg: 'Le référent '+referent.firstname+' '+referent.lastname+', peut désormais gérer le Neopass du bénéficiaire '+beneficiary.firstname+' '+beneficiary.lastname});
          setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
        })
          .catch(error => {
            store.commit('permissions/SET_MESSAGEHEADER', {type: 'error', msg: 'Erreur d`\'enregistrement des données.'});

            setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);

            console.log('ERRRR:: ', error.response.data);
          });
      }
    },

    async addBeneficiariesToReferent(context){
      const isIncluded = (value) => context.getters.beneficiariesToAdd.includes(value);
      if(context.getters.selectedBeneficiaries.every(isIncluded)){ //only if beneficiary exists
        store.commit('permissions/SET_SAVING', true);
        let referent = store.getters['referents/referentToEdit'],
          beneficiariesCount = context.getters.selectedBeneficiaries.length;

        await axios.post('/api/user-beneficiaries/'+referent.id, {beneficiaries: context.getters.selectedBeneficiaries}).then(async () => {
          await context.dispatch('loadBeneficiariesReferent', referent.id);
          await context.commit('SET_SELECTEDBENEFICIARIES', []);

          let hasMany =  beneficiariesCount > 1; // To know if use plural in message
          let message = 'Le référent '+referent.firstname+' '+referent.lastname+', peut désormais gérer le Neopass de '+beneficiariesCount+' nouveau' + (hasMany ? 'x' : '') + ' bénéficiaire' + (hasMany ? 's' : '');
          await store.commit('permissions/SET_SAVING', false);
          await store.commit('permissions/SET_MESSAGEHEADER', {type: 'success', msg: message});
          await setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
        })
          .catch(error => {
            store.commit('permissions/SET_SAVING', false);
            store.commit('permissions/SET_MESSAGEHEADER', {type: 'error', msg: 'Erreur d`\'enregistrement des données.'});
            setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
            console.log('ERRRR:: ', error.response.data);
          });
      }
    },

    /**
         * save Beneficiary in a referent permimeter
         * @param {*} context
         * @param object datas => {id_referent, id_beneficiary}
         */
    async saveBeneficiariesToReferent(context, {typeSave= 'default', beneficiary}){
      if(context.getters.beneficiariesReferent.length === 0){
        return; 
      }

      let referent = store.getters['referents/referentToEdit'];
      //let beneficiaries = context.getters.beneficiariesReferent;

      await axios.put('/api/user-beneficiaries/', {beneficiary: beneficiary}).then(() => {
        context.dispatch('loadBeneficiariesReferent', referent.id);

        context.commit('SET_SELECTEDBENEFICIARIES', []);

        let message = '';
        switch (typeSave) {
        case 'default':
          message = 'La liste des Neopass à gérer du référent '+referent.firstname+' '+referent.lastname+' a bien été modifié';
          break;
        case 'role':
          message = 'Le rôle du référent '+referent.firstname+' '+referent.lastname+' a bien été modifié';
          break;
        default:
          message = 'La liste des Neopass à gérer du référent '+referent.firstname+' '+referent.lastname+' a bien été modifié';
          break;
        }

        store.commit('permissions/SET_MESSAGEHEADER', {type: 'success', msg: message});
        setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
      })
        .catch(error => {
          store.commit('permissions/SET_MESSAGEHEADER', {type: 'error', msg: 'Erreur d`\'enregistrement des données.'});

          setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);

          console.log('ERRRR:: ', error.response.data);
        });
    },

    /**
         * Extract referent specify rights for a beneficiary
         * @param {*} context
         */
    async loadBeneficiaryReferentRights(context){
      if(context.getters.beneficiaryReferentToEdit != undefined && context.getters.beneficiaryReferentToEdit != {}
            && store.getters['referents/referentToEdit'] != undefined && store.getters['referents/referentToEdit'] != {}){

        let beneficiary = context.getters.beneficiaryReferentToEdit;
        let referent = store.getters['referents/referentToEdit'];

        axios.get('api/user-specific-rights/'+referent.id+'/'+beneficiary.id).then((response)=>{
          context.commit('SET_SPECIFICRIGHTSTOEDIT', response.data);
        });
      }
    },

    /**
         * Save specific rights for referent to a beneficiary
         * @param {*} context
         * @param object datas => {id_referent, id_beneficiary}
         */
    async saveSpecificRights(context) {
      store.commit('permissions/SET_SAVING', true);

      let referent = store.getters['referents/referentToEdit'];
      let beneficiary = context.getters.beneficiaryReferentToEdit;

      console.log(context.getters.specificRightsToEdit);
      await axios.put('/api/user-specific-rights/'+referent.id+'/'+beneficiary.id, context.getters.specificRightsToEdit).then(() => {
        store.commit('permissions/SET_MESSAGEHEADER', {type: 'success', msg: 'Les droits spécifiques sur le Neopass de '+beneficiary.firstname+' '+beneficiary.lastname+' ont bien été enregistrés.'});
        store.commit('permissions/SET_SAVING', false);
        setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
      }).catch(error => {
        store.commit('permissions/SET_MESSAGEHEADER', {type: 'error', msg: 'Erreur d`\'enregistrement des données.'});
        setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
        console.log('ERRRR:: ', error.response.data);
      });
    },

    async deleteRightsToBeneficiary(context){
      await store.commit('permissions/SET_SAVING', true);
      let referent = store.getters['referents/referentToEdit'];
      let beneficiary = context.getters.beneficiaryReferentToEdit;

      axios.delete('api/user-beneficiaries/'+referent.id+'/'+beneficiary.id).then(async ()=>{
        await context.dispatch('loadBeneficiariesReferent', referent.id);
        await store.commit('permissions/SET_SAVING', false);

        await store.commit('permissions/SET_MESSAGEHEADER', {
          type: 'success',
          msg: 'Le référent '+referent.firstname+' '+referent.lastname+' ne peut plus gérer le Neopass du bénéficiaire '+beneficiary.firstname+' '+beneficiary.lastname+'.'
        });

        await setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
      }).catch(error => {
        store.commit('permissions/SET_SAVING', false);
        this.SET_MESSAGEHEADER({type: 'error', msg: 'Le benéficiaire n\'a pas pu être enlevé du périmètre du référent'});
        setTimeout(() => {store.commit('permissions/SET_MESSAGEHEADER', null);}, 3000);
        console.log('ERRRR:: ', error.response.data);
      });
    },

    selectAllBeneficiaries(context){
      if (context.getters.selectedBeneficiaries.length === context.getters.beneficiariesToAdd.length){
        context.commit('SET_SELECTEDBENEFICIARIES', []);
      }else{
        context.commit('SET_SELECTEDBENEFICIARIES', context.getters.beneficiariesToAdd);
      }
    },

    selectBeneficiary(context, beneficiary){
      if (context.getters.selectedBeneficiaries.filter(b => b.id === beneficiary.id).length === 1){
        let selected = context.getters.selectedBeneficiaries.filter(b => b.id !== beneficiary.id);
        context.commit('SET_SELECTEDBENEFICIARIES', selected);
      }else {
        let selected = context.getters.selectedBeneficiaries.concat([beneficiary]);
        context.commit('SET_SELECTEDBENEFICIARIES', selected);
      }
    }
  },
};
